var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8045 14.862L11.2545 10.312C12.1359 9.22334 12.6665 7.84 12.6665 6.33334C12.6665 2.84134 9.8252 0 6.33324 0C2.84128 0 0 2.84131 0 6.33331C0 9.82531 2.84131 12.6667 6.33327 12.6667C7.83991 12.6667 9.22324 12.136 10.3119 11.2547L14.8618 15.8047C14.9918 15.9347 15.1625 16 15.3332 16C15.5039 16 15.6745 15.9347 15.8045 15.8047C16.0652 15.544 16.0652 15.1227 15.8045 14.862ZM6.33327 11.3333C3.57596 11.3333 1.33333 9.09066 1.33333 6.33331C1.33333 3.57597 3.57596 1.33331 6.33327 1.33331C9.09059 1.33331 11.3332 3.57597 11.3332 6.33331C11.3332 9.09066 9.09056 11.3333 6.33327 11.3333Z",
    fill: "#C8D0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.5f047400.svg";
export { ForwardRef as ReactComponent };